import React, { useState } from 'react'
import Button from 'components/Button/Button'
import { AppHeaderAuthContainer } from './styled'
import SignInModal from 'components/SignInModal/SignInModal'
import { useHistory } from 'react-router'

const AppHeaderAuth: React.FC = () => {
  const { push } = useHistory()
  const [openModal, setOpenModal] = useState<boolean>(false)

  const toggleModal = () => {
    setOpenModal(!openModal)
  }

  return (
    <AppHeaderAuthContainer>
      <Button
        text="Login"
        variant="neutral"
        size="tiny"
        style={{
          margin: '0px 10px',
          color: 'black',
          background: 'transparent',
        }}
        onClick={toggleModal}
      />
      <Button
        text="Sign Up"
        variant="primary"
        size="tiny"
        style={{ padding: '0px 26px' }}
        onClick={() => push('/sign-up')}
      />
      {openModal && <SignInModal onModalClose={toggleModal} />}
    </AppHeaderAuthContainer>
  )
}

export default AppHeaderAuth
